var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M512 211.863H229.517V88.277h-88.276v123.586H0v88.276h141.241v123.586h88.276V300.139H512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M512 229.518H211.862V88.277h-52.965v141.241H0v52.966h158.897v141.241h52.965V282.484H512z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIs);
export default __webpack_public_path__ + "static/media/is.13434be6de809ce198d83b11f8910cfe.svg";
export { ForwardRef as ReactComponent };